const auth = {
  signIn: "Войти",
  signOut: "Выйти",
  email: "Эл. почта",
  password: "Пароль",
  forgotPassword: "Забыли пароль?",
  resetPassword: "Сбросить пароль",
  resetSent: "Ссылка для сброса пароля отправлена",
  invalidCredentials: "Неверный email или пароль",
  sessionExpired: "Сессия истекла — войдите снова",
  welcomeBack: "С возвращением",
  signInToCommand: "Войти в Командный центр",
  newPassword: "Новый пароль",
  passwordUpdated: "Пароль успешно обновлён",
  otpCode: "Одноразовый код",
  sendCode: "Отправить код",
  verifyCode: "Подтвердить код",
  codeSent: "Код отправлен на вашу почту",
  invalidCode: "Неверный код — попробуйте снова",
  resendCode: "Отправить код повторно",
  or: "или",
  signInWithGoogle: "Войти через Google",
  signInWithGithub: "Войти через GitHub",
  signInWithFacebook: "Войти через Facebook",
  signInWithMicrosoft: "Войти через Microsoft",
  signInWithApple: "Войти через Apple",
  signInWithLinkedIn: "Войти через LinkedIn",
  continueWith: "или продолжить через",
  createAccount: "Создать аккаунт",
  registerSubtitle: "Регистрация в Командном центре",
  alreadyHaveAccount: "Уже есть аккаунт? Войти",
  displayName: "Полное имя",
  displayNamePlaceholder: "Ваше имя",
  profileSetup: "Настройка профиля",
  completeRegistration: "Завершить регистрацию",
  changeEmail: "Изменить email",
  unauthorized: "Нет доступа к системе",
  inviteOnly: "Доступ только по приглашению",
  accountPending: "Ваш аккаунт ожидает подтверждения",
} as const;
export default auth;
